export default __webpack_public_path__ + "static/azurebeach-3dcfb73e731da41d68db372dd110b0c7.webp";